import React from 'react';
import { Button } from './Button';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="bg-cream pt-12 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-62">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-12" data-id="element-63">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="flex-1 text-center lg:text-left z-10" data-id="element-64">
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-forest font-bold leading-tight mb-6" data-id="element-65">
            Desinflama tu cuerpo en 72 horas y vuelve a sentirte ligera, cómoda
            y segura en tu ropa
          </h1>
          <h2 className="text-xl md:text-2xl text-forest-light font-medium mb-8" data-id="element-66">
            Una guía digital en español, creada para mujeres latinas en USA, con
            pasos simples para reducir la hinchazón, sentir menos pesadez y
            empezar un reset práctico desde casa.
          </h2>
          <p className="text-gray-700 text-lg mb-10 leading-relaxed" data-id="element-67">
            ¿Te despertaste hoy sintiéndote "bien", pero a esta hora ya sientes
            que tu abdomen va a estallar? No eres tú, es tu cuerpo atrapado en
            un ciclo de inflamación que ninguna dieta tradicional puede romper.
            <br data-id="element-68" />
            <br data-id="element-69" />
            Sabes de qué hablo: esa pesadez que te quita la energía, los anillos
            que no salen de tus dedos al final del día y esa frustración frente
            al espejo cuando el vestido que tanto te gusta simplemente no
            cierra.
          </p>
          <Button data-id="element-70">¡SÍ, QUIERO DESINFLAMARME AHORA!</Button>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="flex-1 w-full max-w-md lg:max-w-full relative" data-id="element-71">
          <div className="absolute inset-0 bg-sage rounded-full blur-3xl opacity-50 transform scale-110" data-id="element-72"></div>
          <img src="https://cdn.magicpatterns.com/uploads/u3h6xU6zEcqbpUAvD2WZDQ/Mockup_PTO_1_Anti-Desinflamacion_72H.png" alt="Protocolo Anti-Inflamación 72h" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl rounded-2xl" data-id="element-73" />
        </motion.div>
      </div>
    </section>;
}